<ngx-spinner>
  <p class="white">登入中⋯⋯</p>
</ngx-spinner>
